export default "__VITE_ASSET__BlXM0qif__"